<template>
  <div>
    <el-row class="rewardKeyConfig__search">
      <div class="item">
        <span>礼包key:</span>
        <el-input
          style="width: 150px"
          v-model.number="searchList.awardsKey"
          clearable
          placeholder="请输入礼包key"
        ></el-input>
      </div>
      <div class="item">
        <span>礼包类型:</span>
        <el-select
          style="width: 100px"
          v-model="searchList.awardsKeyType"
          filterable
          placeholder="请选择"
        >
          <el-option
            v-for="(item, index) in awardsKeyTypeList"
            :key="index"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <div class="item">
        <span>状态:</span>
        <el-select
          style="width: 100px"
          v-model="searchList.valid"
          filterable
          placeholder="请选择"
        >
          <el-option
            v-for="(item, index) in validList"
            :key="index"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <el-button style="margin-left: 10px" type="primary" @click="getList(1)"
        >查询</el-button
      >
      <el-button
        style="margin-left: 10px"
        type="success"
        @click="
          () => {
            type = 0
            isShow = true
          }
        "
        >创建</el-button
      >
    </el-row>
    <!-- 表格 -->
    <el-row>
      <el-table border :data="tableList">
        <el-table-column prop="id" label="ID" align="center"> </el-table-column>
        <el-table-column
          prop="awardsKey"
          label="礼包key"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="awardsName"
          label="礼包名称"
          align="center"
        ></el-table-column>
        <el-table-column prop="awardsKeyType" label="礼包类型" align="center">
          <template slot-scope="scope">
            {{
              awardsKeyTypeList.find(
                (item) => item.value === scope.row.awardsKeyType
              ).label || ''
            }}
          </template>
        </el-table-column>
        <el-table-column prop="awardsIcon" label="礼包图标" align="center">
          <template slot-scope="scope">
            <el-image
              :src="scope.row.awardsIcon"
              style="width: 100px; height: 100px"
              :preview-src-list="[scope.row.awardsIcon]"
            />
          </template>
        </el-table-column>
        <el-table-column
          prop="ctime"
          :formatter="formatDate"
          label="创建时间"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="mtime"
          :formatter="formatDate"
          label="修改时间"
          align="center"
        ></el-table-column>
        <el-table-column prop="valid" label="状态" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.valid == 1" type="success">有效</el-tag>
            <el-tag v-else type="danger">无效</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作人" align="center" prop="operator">
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <div
              style="
                display: flex;
                gap: 10px;
                width: 100%;
                flex-direction: column;
              "
            >
              <el-button
                style="margin: auto"
                type="warning"
                @click="copy(scope.row)"
                >复制</el-button
              >
              <el-button
                style="margin: auto"
                type="success"
                @click="showGive(scope.row)"
                >下发</el-button
              >
              <el-button
                style="margin: auto"
                type="primary"
                @click="edit(scope.row)"
                >编辑</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <!-- 分页 -->
    <el-row>
      <el-pagination
        background
        layout="prev, pager, next"
        :total="total"
        :page-size="searchList.pageSize"
        @current-change="guaranteedHandleCurrentChange"
      >
      </el-pagination>
    </el-row>
    <!-- 下发奖励 -->
    <el-dialog
      title="下发奖励"
      :visible.sync="isShowGive"
      width="30%"
      @close="close(0)"
    >
      <el-form
        :model="giveForm"
        label-width="auto"
        :rules="ruleList"
        ref="giveFormRef"
        class="giveForm"
      >
        <el-form-item label="礼包key" prop="awardsKey">
          <el-input
            style="width: 150px"
            v-model="giveForm.awardsKey"
          ></el-input>
        </el-form-item>
        <el-form-item label="用户rid" prop="rid">
          <el-input
            style="width: 150px"
            v-model.number="giveForm.rid"
          ></el-input>
        </el-form-item>
        <el-form-item label="活动码" prop="eventCode">
          <el-input
            style="width: 150px"
            v-model.number="giveForm.eventCode"
          ></el-input>
        </el-form-item>
        <el-form-item label="变动描述">
          <el-input
            type="textarea"
            style="width: 150px"
            v-model="giveForm.changeDesc"
          ></el-input>
        </el-form-item>
        <el-form-item label="描述明细">
          <el-input
            type="textarea"
            style="width: 150px"
            v-model="giveForm.descDetail"
          ></el-input>
        </el-form-item>
        <el-form-item label="金币流水描述">
          <el-input
            type="textarea"
            style="width: 150px"
            v-model="giveForm.actDesc"
          ></el-input>
        </el-form-item>
        <el-form-item label="活动链接" prop="eventUrl">
          <el-input style="width: 150px" v-model="giveForm.eventUrl"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="close(0)">取消</el-button>
          <el-button type="primary" @click="give(giveForm)">下发</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 创建 / 编辑 -->
    <el-drawer
      :title="type == 0 ? '创建' : '编辑'"
      :visible.sync="isShow"
      width="30%"
      @close="close(1)"
    >
      <div style="display: flex; padding-left: 30px; height: 100%">
        <el-form
          :model="form"
          label-position="right"
          label-width="140px"
          :rules="ruleList"
          ref="formRef"
          style="width: 100%"
        >
          <el-form-item label="礼包key" prop="awardsKey">
            <el-input
              style="width: 150px"
              v-model="form.awardsKey"
              :disabled="type == 1"
            ></el-input>
          </el-form-item>
          <el-form-item label="礼包名称" prop="awardsName">
            <el-input style="width: 150px" v-model="form.awardsName"></el-input>
          </el-form-item>
          <el-form-item label="礼包类型" prop="awardsKeyType">
            <el-select
              style="width: 150px"
              v-model="form.awardsKeyType"
              filterable
              placeholder="请选择"
            >
              <el-option
                v-for="(item, index) in awardsKeyTypeList"
                :key="index"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="礼包图标" prop="awardsIcon">
            <div style="display: flex; align-items: center; gap: 10px">
              <UploadSingleImg
                v-model="form.awardsIcon"
                :on-upload="
                  (file) => uploadFile(file, 'event/reward_key/icon/')
                "
              />
              <el-input
                clearable
                style="width: 40%"
                v-model="form.awardsIcon"
                placeholder="图片链接"
              ></el-input>
            </div>
          </el-form-item>
          <el-form-item label="是否有效" prop="valid">
            <el-switch
              v-model="form.valid"
              :active-value="1"
              :inactive-value="0"
              active-text="是"
              inactive-text="否"
            ></el-switch>
          </el-form-item>
          <el-row>
            <el-button
              style="margin-left: 40px"
              type="success"
              @click="addAwardInfo"
              >添加资源</el-button
            >
          </el-row>
          <div style="width: 100%">
            <el-collapse v-model="activeName" accordion>
              <el-collapse-item
                v-for="(item, index) in form.awardInfoList.filter(
                  (item) => item
                )"
                :key="index"
                :name="index"
              >
                <template slot="title">
                  资源{{ index + 1 }}
                  <div
                    @click.stop="confirmDelete(index)"
                    style="cursor: pointer; margin-left: 100px"
                  >
                    <el-icon class="el-icon-delete-solid"></el-icon>
                  </div>
                </template>
                <el-row>
                  <el-button
                    type="primary"
                    style="margin-left: 140px"
                    @click="getGiftResource(item, index)"
                    >选取资源</el-button
                  >
                </el-row>
                <el-form-item label="奖励id">
                  <el-input
                    style="width: 150px"
                    v-model.number="item.awardId"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  :label="'奖励类型'"
                  :prop="`awardInfoList[${index}].awardType`"
                >
                  <el-select
                    style="width: 150px"
                    v-model.number="item.awardType"
                    filterable
                    placeholder="请选择"
                    @change="onAwardTypeChange(item, index)"
                  >
                    <el-option
                      v-for="(item, index) in giftTypeList"
                      :key="index"
                      :label="item.name"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item
                  :label="'奖励对应的数据ID'"
                  :prop="`awardInfoList[${index}].dataId`"
                >
                  <el-input
                    style="width: 150px"
                    v-model.number="item.dataId"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  :label="'奖励下发数量'"
                  :prop="`awardInfoList[${index}].nums`"
                >
                  <el-input
                    style="width: 150px"
                    v-model.number="item.nums"
                  ></el-input>
                </el-form-item>
                <el-form-item label="奖励名称">
                  <el-input
                    style="width: 150px"
                    v-model="item.awardName"
                  ></el-input>
                </el-form-item>
                <el-form-item label="奖励图标">
                  <div style="display: flex; align-items: center; gap: 10px">
                    <UploadSingleImg
                      v-model="item.awardIcon"
                      :on-upload="
                        (file) => uploadFile(file, 'event/reward_key/icon/')
                      "
                    />
                    <el-input
                      style="width: 150px"
                      v-model="item.awardIcon"
                      placeholder="链接"
                    ></el-input>
                  </div>
                </el-form-item>
                <el-form-item label="奖励预览图(支持MP4)">
                  <div style="display: flex; align-items: center; gap: 10px">
                    <UploadSingleImg
                      v-model="item.awardVideoUrl"
                      :on-upload="
                        (file) => uploadFile(file, 'event/reward_key/video/')
                      "
                    />
                    <el-input
                      style="width: 150px"
                      v-model="item.awardVideoUrl"
                      placeholder="链接"
                    ></el-input>
                  </div>
                </el-form-item>
                <el-form-item label="单位价值">
                  <el-input
                    style="width: 150px"
                    v-model.number="item.unitPrice"
                    :disabled="
                      item.awardType === 1 ||
                      item.awardType === 2 ||
                      item.awardType === 9
                    "
                  ></el-input>
                </el-form-item>
                <el-form-item label="展示价格">
                  <el-input
                    style="width: 150px"
                    v-model="item.showPrice"
                  ></el-input>
                </el-form-item>
                <el-form-item label="展示数量">
                  <el-input
                    style="width: 150px"
                    v-model="item.showNums"
                  ></el-input>
                </el-form-item>
                <template v-if="form.awardsKeyType == 2">
                  <el-form-item label="概率">
                    <el-input
                      style="width: 150px"
                      v-model.number="item.rate"
                    ></el-input>
                    <div class="tip" style="color: red">
                      <span>默认奖池概率</span>
                    </div>
                  </el-form-item>
                  <el-form-item label="概率1">
                    <el-input
                      style="width: 150px"
                      v-model.number="item.rate1"
                    ></el-input>
                    <div class="tip" style="color: red">
                      <span>三方充值达标奖池概率</span>
                    </div>
                  </el-form-item>
                  <el-form-item label="概率2">
                    <el-input
                      style="width: 150px"
                      v-model.number="item.rate2"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="概率3">
                    <el-input
                      style="width: 150px"
                      v-model.number="item.rate3"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="限制数量">
                    <el-input
                      style="width: 150px"
                      v-model.number="item.limit"
                    ></el-input>
                    <div class="tip" style="color: red">
                      <span
                        >全局限制数量 (-1 不限制) (0 直接不入奖池) (>=0
                        限制)</span
                      >
                    </div>
                  </el-form-item>
                </template>
                <el-form-item label="是否自动佩戴">
                  <el-switch
                    v-model="item.autoWear"
                    :active-value="true"
                    :inactive-value="false"
                    active-text="是"
                    inactive-text="否"
                  ></el-switch>
                </el-form-item>
                <el-form-item label="是否房间飘萍">
                  <el-switch
                    v-model="item.roomFloating"
                    :active-value="true"
                    :inactive-value="false"
                    active-text="是"
                    inactive-text="否"
                  ></el-switch>
                </el-form-item>
                <el-form-item label="是否全服公告">
                  <el-switch
                    v-model="item.fullServiceNotice"
                    :active-value="true"
                    :inactive-value="false"
                    active-text="是"
                    inactive-text="否"
                  ></el-switch>
                </el-form-item>
                <el-form-item label="是否个人弹窗">
                  <el-switch
                    v-model="item.personalPopup"
                    :active-value="true"
                    :inactive-value="false"
                    active-text="是"
                    inactive-text="否"
                  ></el-switch>
                </el-form-item>
                <el-form-item label="是否全服弹窗">
                  <el-switch
                    v-model="item.fullServicePopup"
                    :active-value="true"
                    :inactive-value="false"
                    active-text="是"
                    inactive-text="否"
                  ></el-switch>
                </el-form-item>
              </el-collapse-item>
            </el-collapse>
          </div>
          <el-row style="margin-top: 20px">
            <el-button type="primary" @click="close(1)">取消</el-button>
            <el-button style="margin-left: 40px" type="success" @click="submit"
              >提交</el-button
            >
          </el-row>
        </el-form>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import UploadSingleImg from '@/components/UploadSingleImg/UploadSingleImg'

export default {
  components: {
    UploadSingleImg,
  },
  data() {
    return {
      // 0 创建 1 编辑
      type: 0,
      activeName: '1',
      searchList: {
        awardsKey: null,
        awardsKeyType: 1,
        valid: 1,
        page: 1,
        pageSize: 10,
      },
      isShow: false,
      isShowGive: false,
      total: 0,
      form: {
        awardsKey: null,
        awardsKeyType: 1,
        awardsName: null,
        awardsIcon: '',
        awardInfoList: [
          {
            awardId: 1,
            awardType: null,
            dataId: null,
            nums: null,
            awardName: null,
            awardIcon: '',
            awardVideoUrl: '',
            unitPrice: 0,
            showPrice: 0,
            showNums: 0,
            rate: null,
            rate1: null,
            rate2: null,
            rate3: null,
            limit: -1,
            autoWear: false,
            roomFloating: false,
            fullServiceNotice: false,
            personalPopup: false,
            fullServicePopup: false,
          },
        ],
        valid: 1,
      },
      tableList: [],
      giftResourceInfo: {},
      giftTypeList: [],
      giveForm: {
        awardsKey: null,
        rid: null,
        eventCode: null,
        changeDesc: null,
        descDetail: null,
        actDesc: null,
        eventUrl: null,
      },
      awardsKeyTypeList: [
        {
          label: '普通类',
          value: 1,
        },
        {
          label: '概率类 ',
          value: 2,
        },
      ],
      validList: [
        {
          label: '有效',
          value: 1,
        },
        {
          label: '无效',
          value: 0,
        },
      ],
      baseRuleList: {
        awardsKey: [
          { required: true, message: '请输入礼包key', trigger: 'blur' },
          {
            pattern: /^[a-zA-Z0-9_-]+$/,
            message: '只能输入字母、数字、下划线和中划线',
            trigger: 'blur',
          },
        ],
        awardsName: [
          { required: true, message: '请输入礼包名称', trigger: 'blur' },
        ],
        awardsKeyType: [
          { required: true, message: '请选择礼包类型', trigger: 'change' },
        ],
        rid: [{ required: true, message: '请输入用户rid', trigger: 'blur' }],
        eventCode: [
          { required: true, message: '请输入事件code', trigger: 'blur' },
        ],
        eventUrl: [
          { required: true, message: '请输入活动链接', trigger: 'blur' },
        ],
      },
    }
  },
  computed: {
    ruleList() {
      const rules = { ...this.baseRuleList }

      // 为每个awardInfoList项添加验证规则
      this.form.awardInfoList.forEach((item, index) => {
        rules[`awardInfoList[${index}].awardType`] = [
          { required: true, message: '请选择奖励类型', trigger: 'change' },
        ]
        rules[`awardInfoList[${index}].dataId`] = [
          {
            required: true,
            message: '请输入奖励对应的数据ID',
            trigger: 'blur',
          },
          {
            validator: (rule, value, callback) => {
              if (item.awardType === 6) {
                if (value < 1 || value > 6) {
                  callback(new Error('贵族天数数据ID必须在1-6之间'))
                }
              }
              callback()
            },
            trigger: 'blur',
          },
        ]
        rules[`awardInfoList[${index}].nums`] = [
          { required: true, message: '请输入奖励下发数量', trigger: 'blur' },
        ]
      })

      return rules
    },
  },
  created() {
    this.getGiftType()
    this.getList()
  },
  methods: {
    // 编辑
    edit(info) {
      this.type = 1
      this.form = info
      this.isShow = true
    },
    // 添加资源
    submit() {
      this.$refs.formRef.validate(async (valid) => {
        const data = JSON.parse(JSON.stringify(this.form))
        data.awardInfoList = data.awardInfoList.filter((item) => item)
        if (valid) {
          if (this.type == 0) {
            this.create(data, this.close(1))
          } else {
            this.update(data, this.close(1))
          }
        }
      })
    },
    addAwardInfo() {
      this.form.awardInfoList.push({
        awardId: this.form.awardInfoList.length + 1,
        awardType: null,
        dataId: null,
        nums: null,
        awardName: null,
        awardIcon: '',
        awardVideoUrl: '',
        unitPrice: 0,
        showPrice: 0,
        showNums: 0,
        rate: null,
        rate1: null,
        rate2: null,
        rate3: null,
        limit: -1,
        autoWear: false,
        roomFloating: false,
        fullServiceNotice: false,
        personalPopup: false,
        fullServicePopup: false,
      })
    },
    async uploadFile(file, dir) {
      const formData = new FormData()
      formData.append('file', file)
      formData.append('cover', 0)
      formData.append('dir', dir)
      const { data: res } = await this.$axios.post(
        this.$store.getters.path.hostmgr_upload +
          '?username=' +
          this.$store.getters.username +
          '&token=' +
          this.$store.getters.token,
        formData
      )
      return { code: res.code, url: res.data }
    },
    close(type) {
      if (type == 0) {
        this.isShowGive = false
        this.giveForm = {
          awardsKey: null,
          rid: null,
          eventCode: null,
          changeDesc: null,
          descDetail: null,
          actDesc: null,
          eventUrl: null,
        }
      } else {
        this.isShow = false
        this.form = {
          awardsKey: null,
          awardsKeyType: 1,
          awardsName: null,
          awardsIcon: '',
          awardInfoList: [
            {
              awardId: 1,
              awardType: null,
              dataId: null,
              nums: null,
              awardName: null,
              awardIcon: '',
              awardVideoUrl: '',
              unitPrice: 0,
              showPrice: 0,
              showNums: 0,
              rate: null,
              rate1: null,
              rate2: null,
              rate3: null,
              limit: -1,
              autoWear: false,
              roomFloating: false,
              fullServiceNotice: false,
              personalPopup: false,
              fullServicePopup: false,
            },
          ],
          valid: 1,
        }
      }
    },
    // 分页
    guaranteedHandleCurrentChange(page) {
      this.getList(page)
    },
    formatDate(row, column) {
      // 获取单元格数据
      let data = row[column.property] * 1000
      if (data == null) {
        return null
      }
      let dt = new Date(data)
      return (
        dt.getFullYear() +
        '-' +
        (dt.getMonth() + 1) +
        '-' +
        dt.getDate() +
        ' ' +
        dt.getHours() +
        ':' +
        dt.getMinutes() +
        ':' +
        dt.getSeconds()
      )
    },
    // 获取数据列表
    async getList(page) {
      if (page) {
        this.searchList.page = page
      }
      const { data: res } = await this.$axios({
        method: 'get',
        url: this.$store.getters.path.config_rewardKey_query,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          ...this.searchList,
        },
      })
      if (res.code === 0 || res.status === 0 || res.code == 200) {
        this.tableList = res.data.data
        this.total = res.data.total
      } else {
        this.$message.error(res.msg || res.message)
      }
    },
    copy(info) {
      this.$prompt('请输入礼包key', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^[a-zA-Z0-9_-]+$/,
        inputErrorMessage: '只能输入字母、数字、下划线和中划线',
      })
        .then(({ value }) => {
          const data = {
            awardsKey: value,
            awardsKeyType: info.awardsKeyType,
            awardsName: info.awardsName,
            awardsIcon: info.awardsIcon,
            awardInfoList: info.awardInfoList,
            valid: info.valid,
          }
          this.create(data)
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入',
          })
        })
    },
    // 创建
    async create(info, func) {
      const data = JSON.parse(JSON.stringify(info))
      console.log(data)
      const { data: res } = await this.$axios({
        method: 'post',
        url: this.$store.getters.path.config_rewardKey_create,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
        },
        data: { ...data, operator: this.$store.getters.username },
      })
      if (res.code === 0 || res.status === 0 || res.code == 200) {
        this.$message.success('创建成功')
        func && func()
        this.getList()
      } else {
        this.$message.error(res.msg || res.message)
      }
    },
    // 更新
    async update(info) {
      const data = JSON.parse(JSON.stringify(info))
      data.operator = this.$store.getters.username
      const { data: res } = await this.$axios({
        method: 'post',
        url: this.$store.getters.path.config_rewardKey_update,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
        },
        data,
      })
      if (res.code === 0 || res.status === 0 || res.code == 200) {
        this.$message.success('更新成功')
        this.getList()
      } else {
        this.$message.error(res.msg || res.message)
      }
    },
    showGive(info) {
      this.isShowGive = true
      this.giveForm.awardsKey = info.awardsKey
    },
    // 下发
    async give(info) {
      this.$refs.giveFormRef.validate(async (valid) => {
        if (valid) {
          const data = JSON.parse(JSON.stringify(info))
          const { data: res } = await this.$axios({
            method: 'post',
            url: this.$store.getters.path.config_rewardKey_give,
            params: {
              username: this.$store.getters.username,
              token: this.$store.getters.token,
            },
            data: {
              ...data,
              operator: this.$store.getters.username,
            },
          })
          if (res.code === 0 || res.status === 0 || res.code == 200) {
            this.$message.success('下发成功')
            this.getList()
            this.close(0)
          } else {
            this.$message.error(res.msg || res.message)
          }
        }
      })
    },
    // 获取礼物资源
    async getGiftResource(info, index) {
      if (info.dataId == null || info.awardType == null) {
        this.$message.error('请先选择奖励类型和奖励对应的数据id')
        return
      }
      const infos = {
        dataId: info.dataId,
        awardType: info.awardType,
      }
      const { data: res } = await this.$axios({
        method: 'get',
        url: this.$store.getters.path.config_rewardList_get,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          ...infos,
        },
      })
      if (res.code === 0 || res.status === 0 || res.code == 200) {
        // 使用Vue.$set来确保响应式更新
        const newData = {
          ...res.data,
          awardId: info.awardId,
        }
        // this.$set(this.form.awardInfoList, index, newData)
        this.form.awardInfoList[index].awardName = newData.awardName
        this.form.awardInfoList[index].awardIcon = newData.awardIcon
        this.form.awardInfoList[index].unitPrice = newData.unitPrice
        this.$message.success('获取成功')
      } else {
        this.$message.error(res.msg || res.message)
      }
    },
    // 获取礼物类型
    async getGiftType() {
      const { data: res } = await this.$axios({
        method: 'GET',
        url: this.$store.getters.path.const_all,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          className: 'com.quhong.enums.RewardItemType',
        },
      })

      if (res.code != 0 && res.code != 200) {
        return this.$message.error(res.msg)
      } else {
        this.giftTypeList = res.data
      }
    },
    // 添加确认删除方法
    confirmDelete(index) {
      this.$confirm('确认删除该资源吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.form.awardInfoList.splice(index, 1)
          this.$message({
            type: 'success',
            message: '删除成功',
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        })
    },
    // 奖励类型变更时清空相关数据
    onAwardTypeChange(item, index) {
      // 清空相关字段
      this.form.awardInfoList[index].dataId = null
      this.form.awardInfoList[index].nums = null
      this.form.awardInfoList[index].awardName = null
      this.form.awardInfoList[index].awardIcon = ''
      this.form.awardInfoList[index].awardVideoUrl = ''
      this.form.awardInfoList[index].unitPrice = 0
      this.form.awardInfoList[index].showPrice = 0
      this.form.awardInfoList[index].showNums = 0
      this.form.awardInfoList[index].rate = null
      this.form.awardInfoList[index].rate1 = null
      this.form.awardInfoList[index].rate2 = null
      this.form.awardInfoList[index].rate3 = null
      this.form.awardInfoList[index].limit = -1
      this.form.awardInfoList[index].autoWear = false
      this.form.awardInfoList[index].roomFloating = false
      this.form.awardInfoList[index].fullServiceNotice = false
      this.form.awardInfoList[index].personalPopup = false
      this.form.awardInfoList[index].fullServicePopup = false
    },
  },
}
</script>
<style scoped lang="scss">
.rewardKeyConfig {
  &__title {
    font-size: 28px;
    font-weight: 700;
    margin-bottom: 20px;
  }

  &__search {
    display: flex;
    flex-wrap: wrap;
    gap: 15px;

    span {
      font-size: 15px;
      margin-right: 15px;
    }

    .searchBtn {
      margin-left: 10px;
    }
  }
}

.giveForm {
  width: 100%;

  .el-input {
    width: 50%;
  }
}
</style>
